<template>
  <div>
    <div class="pk-page-spacing-flex"></div>
    <nav class="pk-navbar pk-flex pk-flex__1">
      <router-link :to="{ path: '/' }" class="pk-nav-home"
        ><img src="../assets/icons/home.svg"
      /></router-link>
      <template>
        <template v-for="(ni, i) of navList">
          <router-link
            :to="ni"
            :key="i"
            :class="
              ni.className +
              (subIsActive(ni.path) ? ' router-link-exact-active' : '')
            "
            :style="ni.style"
            v-html="ni.inner"
          ></router-link>
        </template>
        <!-- <router-link :to="{path:'/search'}"
       class="pk-nav-search"><img src="../assets/icons/search.svg"></router-link> -->
        <div
          title="searching still under development"
          @click="clickSearchButtonUnderDev()"
          class="pk-nav-search"
        >
          <img src="../assets/icons/search_inactive.svg" />
        </div>
        <!-- <router-link :to="{path:'/help'}"
       class="pk-nav-help"><img src="../assets/icons/help.svg"></router-link> -->
      </template>
    </nav>
    <div class="pk-page-spacing-flex"></div>
    <nav class="pk-navbar pk-flex" style="width: 300px">
      <a
        target="_blank"
        :href="companionHref"
        class="pk-nav-menuitem pk-flex__h-center pk-flex__1"
        style="padding: 0 10px; width: auto"
        >eLaterna&nbsp;Companion</a
      >
      <a
        target="_blank"
        href="http://lucerna.exeter.ac.uk/"
        class="pk-nav-menuitem pk-flex__h-center pk-flex__00auto"
        style="padding: 0; width: 40%; margin: 0px"
        >Lucerna</a
      >
    </nav>
    <modal
      name="pk-nav-search-ud-modal"
      style="background-color: rgba(0, 0, 0, 0.65)"
      :width="'500px'"
      :height="'200px'"
      :clickToClose="true"
    >
      <div class="pk-nav-search-ud-modal-wrapper">
        Functionality of searching is under development.
      </div>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      companionHref: " http://elaterna-companion.uni-trier.de",
      // companionHref: "http://tcdh01.uni-trier.de:9191",
      navList: [
        {
          path: "/ea",
          inner: "eLaterna&nbsp;Archive",
          className: "pk-nav-menuitem pk-flex__h-center",
          style: "",
        },
        {
          path: "/ae",
          inner: "Archive&nbsp;Editions",
          className: "pk-nav-menuitem pk-flex__h-center",
          style: "",
        },
        {
          path: "/ce",
          inner: "Critical&nbsp;Editions",
          className: "pk-nav-menuitem pk-flex__h-center",
          style: "",
        },
      ],
    };
  },
  methods: {
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0;
      });
    },
    clickSearchButtonUnderDev() {
      // window.alert('Search function is under development.');
      this.$modal.show("pk-nav-search-ud-modal");
    },
  },
});
</script>
<style lang="scss">
@import "../assets/scss/nav.scss";

.pk-nav-search-ud-modal-wrapper {
  margin: 20px 20px 20px 20px;
}
</style>